var exports = {
  "f": "ReactionViewerAnchorButton__BIXMSn",
};

module.exports = exports;
